// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Api from "./api/api";
import * as echarts from 'echarts';
import "@/assets/style/public.css";
import "@/assets/style/elementStyle.less";
import { isPc } from "./utils/utils";
import Vant from 'vant';
import 'vant/lib/index.less';
import VueCron from 'vue-cron';

Vue.config.productionTip = false;
Vue.use(Api);
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.use(Vant);
Vue.use(VueCron);


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const requireAuth = to.meta.requireAuth
  // 判断该路由是否需要登录权限
  if (requireAuth) {
    if (localStorage.getItem('_token')) {
      next()
    } else {
      if(isPc()){
        next('/pc/login')
      }else{
        next('/mobile/login')
      }
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js